import styled from "styled-components";
import Input from "../../../../../Form/Input";

export const ResponsiveModalInput = styled(Input)``;
